import { render } from "./AdminsPanel.vue?vue&type=template&id=ec4735ba&scoped=true"
import script from "./AdminsPanel.vue?vue&type=script&lang=js"
export * from "./AdminsPanel.vue?vue&type=script&lang=js"

import "./AdminsPanel.vue?vue&type=style&index=0&id=ec4735ba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4735ba"]])

export default __exports__